import { render, staticRenderFns } from "./online-answersheet-info-dialog.vue?vue&type=template&id=3b6824e2&scoped=true"
import script from "./online-answersheet-info-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./online-answersheet-info-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./online-answersheet-info-dialog.vue?vue&type=style&index=0&id=3b6824e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6824e2",
  null
  
)

export default component.exports